define('services/timeService',[
    'lib/knockout',
    'moment',
    'lib/bluebird',
    'services/apiCore',
    'services/loggingService',
    'services/authService'
], function (
    ko,
    moment,
    Promise,
    apiCore,
    loggingService,
    authService
) {
    'use strict';

    var offset;
    var MILLISECONDS = 'milliseconds';
    var initialized = ko.observable(false);

    /**
     * Get the current time that is corrected by applying any offset from the current server time.  This time
     * should be used when calculating a relative time using a server based timestamp.   This will help to correct
     * the case where the client's clock may be off from the server's.
     *
     * @returns {Promise} A promise that resolves to a moment that represents the corrected current time.
     */

    var init = function () {
        var t0 = moment();
        return apiCore.v2.get('/date')
            .then(function (serverDate) {
                var t1 = moment(serverDate.currentDate);
                // TODO:  Pull DATE header from response to get a better measure of when the
                // response was sent.
                var t2 = t1;
                var t3 = moment();

                // Offset algorithm:  http://en.wikipedia.org/wiki/Network_Time_Protocol#Clock_synchronization_algorithm
                offset = (t1.diff(t0) + t2.diff(t3)) / 2;
                loggingService.debug('Server time offset is: ' + offset / 1000 + ' seconds.');
            })
            .catch(function (err) {
                loggingService.error('An error occurred when getting the server date to calculate the clock offset. Using an offset of 0ms', err);
                offset = 0;
            });
    };

    var timeService = {

        initialized: ko.computed(function () {
            return initialized();
        }),

        /**
         * Get the current server time offset in milliseconds
         * @returns {Integer} the offset in milliseconds
         */
        getOffset: function () {
            return offset;
        },

        /**
         * Returns the current moment if timeService has been initialized.
         * @returns {moment} the corrected current time offset to match server time.
         */
        getTime: function () {
            if(offset){
                return moment().add(offset, MILLISECONDS);
            } else {
                return moment();
            }
        },

    };

    ko.computed(function (){
        if(authService.principalId()){
            init().then(function () {
                initialized(true);
            });
        } else {
            initialized(false);
        }
    });

    return timeService;

});

